import { getScrollBehavior } from '@/client/utils/dom';
import { memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';

// DPIN gold hero (ported from AIP's neon hero, brand copy per
// dpin-redesign-design.md §5 + dpin-redesign-mock.html hero section).
const ORBS: [number, string][] = [
  [10, '14%'], [20, '38%'], [36, '12%'], [55, '32%'], [68, '18%'], [82, '40%'], [93, '22%'],
];

export const TheHero = memo(() => {
  const { t } = useTranslation(['home']);
  const heroRef = useRef<HTMLDivElement>(null);
  const [, navigate] = useLocation();

  const scrollToMarkets = () => {
    document.querySelector('#market-list')?.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
  };
  // How-it-works lives on its own page (7/23), not a home section.
  const goToHowItWorks = () => navigate('/how-it-works');

  return (
    <header ref={heroRef} className="neon-hero">
      {/* animated background scoped to the hero region */}
      <div className="neon-bgwrap" aria-hidden style={{ height: 1100 }}>
        <div className="neon-bg-grid" />
        <div className="neon-bg-glow g1" />
        <div className="neon-bg-glow g2" />
        <div className="neon-bg-glow g3" />
        {ORBS.map((o, i) => (
          <span key={i} className="neon-orb" style={{ left: `${o[0]}%`, top: o[1], animationDelay: `${i * -1.7}s` }} />
        ))}
      </div>

      <h1 className="neon-h1">
        {t('hero-title-1', 'Prediction markets')}
        <br />
        {t('hero-title-2', 'on ')}
        <span className="neon">{t('hero-title-neon', 'DPIN')}</span>
        {t('hero-title-3', ', settled on-chain')}
      </h1>
      <p className="neon-sub">
        {t(
          'hero-sub',
          'Back your view on AI, crypto and macro with DPS or DPN. Prices track the market, positions pay out 1:1.'
        )}
      </p>
      <div className="neon-ctas">
        <button type="button" className="neon-cta-primary" onClick={scrollToMarkets}>
          {t('hero-explore', 'Explore markets')}
        </button>
        <button type="button" className="neon-cta-ghost" onClick={goToHowItWorks}>
          {t('hero-how-it-works', 'How it works')}
        </button>
      </div>
    </header>
  );
});

TheHero.displayName = 'TheHero';
